import { CompanyClient } from 'module/api/company';
import { axiosInstance } from '../axios';
import {
  KanbanBoardResponse,
  KanbanCountResponse,
  KanbanFilterPayload,
  KanbanPaginationParams,
  SignalOccurrence,
  SignalOccurrenceParams,
} from './types';
//export const CompanyAPI = new CompanyClient(axiosInstance);

class CompanyAPIClient extends CompanyClient {
  public constructor() {
    super(axiosInstance);
  }
  public getKanbanCount = async (): Promise<KanbanCountResponse> => {
    try {
      return await this.post<KanbanCountResponse, Record<string, never>>(
        '/scarlet/company/getlightkanbanCount',
        {},
      );
    } catch (error) {
      throw new Error('Failed to get kanban count', { cause: error });
    }
  };

  public getAccountSignalBoard = async (
    params: KanbanPaginationParams,
  ): Promise<KanbanBoardResponse> => {
    try {
      const queryParams = new URLSearchParams();

      queryParams.set('offset', params.offset.toString());
      queryParams.set('limit', params.limit.toString());
      if (params.colId) {
        queryParams.set('colId', params.colId);
      }
      if (params.search) {
        queryParams.set('company*companyName.contains', params.search);
      }

      const url = `/scarlet/company/getlightkanbanV1?${queryParams.toString()}`;
      const body: { filter?: KanbanFilterPayload } = params.filterPayload
        ? { filter: params.filterPayload }
        : {};

      return await this.post<
        KanbanBoardResponse,
        { filter?: KanbanFilterPayload }
      >(url, body);
    } catch (error) {
      throw new Error('Failed to get account signal board', { cause: error });
    }
  };
  public getSignalOccurrence = async (
    params: SignalOccurrenceParams,
  ): Promise<SignalOccurrence[]> => {
    try {
      const { signalOccurrenceId } = params;
      const response = await this.get(
        `/signal-occurrences?signalOccurrenceIds=${signalOccurrenceId}`,
      );

      return response as SignalOccurrence[];
    } catch (error) {
      throw new Error('Failed to get signal occurrences', { cause: error });
    }
  };
}

export const CompanyAPI = new CompanyAPIClient();
